//#region Imports
import { BaseService } from '@app/core/services/base-service.service';
import { DialogService } from '@app/core/services/dialog-service.service';
import { GenericMemberResponsePortalResponseDto } from '@app/core/models/genericMembeResponsePortalResponseDto';
import { Helper } from '@rawlings/core';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginResultDto } from '../model/loginResultDto';
import { NavigationService } from './navigation.service';
import { NotifierService } from '@app/core/services/notifier-service';
import { Observable, firstValueFrom } from 'rxjs';
import { PAGES_ROUTES, UNAUTHORIZED_MESSAGE } from '../model/constants';
import { SessionLogoutDialogComponent } from '../shared/components/session-logout-dialog/session-logout-dialog.component';
import { SessionStorageService } from './session-storage.service';
import { SharedMemberResponseService } from './shared-member-response.service';

//#endregion Imports
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService extends BaseService {
    //#region Constructor
    constructor(
        http: HttpClient,
        private dialogService: DialogService,
        private navigationService: NavigationService,
        private notifierService: NotifierService,
        private sessionStorageService : SessionStorageService,
        private sharedMemberResponseService: SharedMemberResponseService
    ){
        super(http);
    }
    //#endregion Constructor

    //#region Public Methods
    public Logout() : void {
        if(this.TokenExist()){
            this.DeactivateUserSession().subscribe();
            this.sharedMemberResponseService.DeleteSession();
        }
    }

    public RedirectToLogin(): void {
        this.navigationService.NavigateTo(PAGES_ROUTES.LOGIN);
    }

    public LogoutAndRedirectToLogin(): void {
        this.Logout();
        this.RedirectToLogin();
    }

    public UnauthorizedRedirectLogin(): void {
        this.sharedMemberResponseService.DeleteSession();
        this.dialogService.OpenDialog(SessionLogoutDialogComponent,UNAUTHORIZED_MESSAGE);
    }

    public CreateSession(data: LoginResultDto): void {
        if(!Helper.IsEmpty(data?.AccessToken)){
            this.sessionStorageService.SaveToken(data?.AccessToken)
        }
    }

    public GetToken(): string | null {
        return this.sessionStorageService.GetToken();
    }

    public TokenExist(): boolean {
        const token : string = this.sessionStorageService.GetToken();
        return !Helper.IsEmpty(token);
    }

    public async IsSessionValid() : Promise<boolean> {
        if(!this.TokenExist()){
            this.UnauthorizedRedirectLogin();
            return false;
        }

        await firstValueFrom(this.ValidateSession());
        return true;
    }

    public ValidateSession(): Observable<GenericMemberResponsePortalResponseDto<boolean>> {
        return this.Get('/usersession/validate');
    }

    public DeactivateUserSession(): Observable<GenericMemberResponsePortalResponseDto<boolean>> {
        return this.Post('/usersession/deactivate', null);
    }
    //#endregion Public Methods

    //#region Private Methods
    //#endregion Private Methods
}
